import { useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import NoPage from "./components/NoPage";
import { protectedRoutes, publicRoutes } from "./config/routes";
import { standaloneRoutes } from "./features/standalone";
import useSocket from "./hooks/useSocket";
import useSessionBootstrap, { isPublicPath } from "./hooks/useSessionBootstrap";

const Redirect = ({ element }) => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();
  if (isPublicPath(location.pathname, location.search)) {
    return element;
  }
  return !token ? <Navigate to="/login" replace /> : element;
};

function App() {
  const { isBootstrapping } = useSessionBootstrap();
  useSocket();

  if (isBootstrapping) {
    return null;
  }

  return (
    <Routes>
      {publicRoutes?.map((route, index) => (
        <Route key={index} {...route} />
      ))}
      {standaloneRoutes?.map((route, index) => (
        <Route
          key={`standalone-${index}`}
          path={route.path}
          element={<Redirect element={route.element} />}
        />
      ))}
      {protectedRoutes?.map((route, index) => (
        <Route key={index} {...route} element={<Redirect {...route} />} />
      ))}
      <Route path="/" element={<Redirect element={<Navigate to="/dashboard" replace />} />} />
      <Route path="*" element={<NoPage />} />
    </Routes>
  );
}

export default App;
